import { z } from "zod";

/**
 * A single audio file inside an audio folder (a Project with kind="audio").
 *
 * An audio track is to an audio folder what a slide is to a lesson: it holds no
 * media of its own, it points at an existing `Audio` document and adds the
 * ordering and display name that the folder needs.
 */
export const AudioTrackSchema = z.object({
  id: z.string(),
  parentId: z.string(),
  audioId: z.string(),
  name: z.string(),
  sortOrder: z.number().nullable(),
  isDeleted: z.boolean(),
  deletedAt: z.date().nullable().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type AudioTrack = z.infer<typeof AudioTrackSchema>;

/**
 * One student's listening record for one audio track. A record exists only once
 * the student has finished the track, so presence of the row *is* "has played" —
 * there is no boolean to keep in sync.
 */
export const AudioTrackPlaySchema = z.object({
  id: z.string(),
  userId: z.string(),
  audioTrackId: z.string(),
  firstPlayedAt: z.date(),
  lastPlayedAt: z.date(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type AudioTrackPlay = z.infer<typeof AudioTrackPlaySchema>;
